import { render, staticRenderFns } from "./ReferenceStockLevels.vue?vue&type=template&id=1b049fe9&scoped=true&"
import script from "./ReferenceStockLevels.vue?vue&type=script&lang=ts&"
export * from "./ReferenceStockLevels.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceStockLevels.vue?vue&type=style&index=0&id=1b049fe9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b049fe9",
  null
  
)

export default component.exports